import * as React from 'preact/compat'
import type { GameRelation } from '../SeriesEditor/types'
import Line from './Line'
import { useContext } from 'preact/compat'
import { SeriesSchemeState } from './state'
import { log } from '../../common/helpers'

interface PropTypes {
  relation: GameRelation
}

export default ({
  relation
}: PropTypes) => {
  const state = useContext(SeriesSchemeState)
  if (!state.container.value) {
    return null
  }

  let sourceElement = state.container.value.querySelector<HTMLElement>(`#node_${relation.first_game_id}`)
  let targetElement = state.container.value.querySelector<HTMLElement>(`#node_${relation.second_game_id}`)

  if (!sourceElement || !targetElement) {
    log('Relation Line', 'Nonexistent element', relation.first_game_id, relation.second_game_id, sourceElement, targetElement)
    return null
  }

  const highlighted = state.highlightedRelations.value.includes(relation)

  return <Line sourceElement={sourceElement} targetElement={targetElement} highlighted={highlighted}/>
}
